import { Link } from "react-router-dom";

const STATS = [
  { value: "1200+", label: "在线漫画" },
  { value: "860万+", label: "注册读者" },
  { value: "500+", label: "完结大结局" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=dreamy%20romantic%20anime%20illustration%20wide%20banner%2C%20a%20young%20couple%20in%20school%20uniforms%20standing%20under%20a%20huge%20cherry%20blossom%20tree%20at%20golden%20sunset%2C%20petals%20swirling%20in%20the%20warm%20breeze%2C%20soft%20glowing%20light%2C%20pastel%20coral%20peach%20and%20gold%20color%20palette%2C%20stylized%20shoujo%20manga%20art%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-home-89890&orientation=landscape"
        alt="89890漫画网 浪漫恋爱漫画横幅"
        title="青梅竹马不断向我甜蜜求婚 漫画大结局免费阅读"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55" />

      <div className="container-site relative z-10 flex w-full flex-col items-center pt-24 pb-16 text-center md:pt-28">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur-sm md:text-sm">
          <i className="ri-fire-fill text-accent-500" aria-hidden="true" />
          热门完结 · 大结局免费畅读
        </span>

        <h1 className="mt-5 max-w-4xl font-heading text-3xl font-bold leading-snug text-white md:text-5xl md:leading-snug">
          89890漫画网 · 青梅竹马不断向我甜蜜求婚
          <span className="mt-2 block text-xl text-white/90 md:text-2xl">漫画大结局免费阅读 · 高清在线畅读</span>
        </h1>

        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
          免费在线阅读《青梅竹马不断向我甜蜜求婚》完整结局章节，还有千余部浪漫恋爱漫画持续更新，随时随地沉浸于甜蜜故事。
        </p>

        <div className="mt-7 flex flex-col items-center gap-3 sm:flex-row">
          <Link to="/article/qingmei?ch=ch-end" className="btn-primary w-full !px-7 !py-3 text-base sm:w-auto">
            <i className="ri-book-open-line text-lg" aria-hidden="true" />
            立即阅读大结局
          </Link>
          <Link
            to="/category/all"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-7 py-3 text-base font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto cursor-pointer"
          >
            <i className="ri-grid-fill text-lg" aria-hidden="true" />
            浏览全部漫画
          </Link>
        </div>

        <dl className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {STATS.map((item) => (
            <div key={item.label} className="text-center">
              <dt className="sr-only">{item.label}</dt>
              <dd className="font-heading text-2xl font-bold text-white md:text-3xl">{item.value}</dd>
              <dd className="mt-1 text-xs text-white/70 md:text-sm">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 animate-bounce text-white/70">
        <i className="ri-arrow-down-s-line text-2xl" aria-hidden="true" />
      </div>
    </section>
  );
}